import PropTypes from 'prop-types';
import React from 'react';
import t from 'app/utils/translate';
import useSheet from '../../jss';
import Button from './Button';
import Modal from './Modal';

const propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  page: PropTypes.string,
  sheet: PropTypes.object.isRequired
};

const defaultProps = {
  isOpen: false,
  page: ''
};

function ContentModal({ isOpen, onCancel, page, sheet: { classes } }) {
  return (
    <Modal size="medium" onCancel={onCancel} isOpen={isOpen}>
      <div className={classes.innerContainer}>
        <div className={`${classes.iframeWrap} overflowYscroll`}>
          <iframe src={page} className="embedFrame" />
        </div>
        <div className={classes.closeButton}>
          <Button block kind="cancel" onClick={onCancel}>
            {t('Close this')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

ContentModal.propTypes = propTypes;
ContentModal.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    innerContainer: {
      height: '85vh'
    },
    iframeWrap: {
      borderBottomColor: theme.color.basis6,
      borderBottomStyle: 'solid',
      borderBottomWidth: 2,
      height: '90%',
      paddingBottom: '10%'
    },
    closeButton: {
      alignItems: 'center',
      background: 'white',
      display: 'flex',
      padding: theme.spacing.default
    },
    [theme.mediaQuery.tabletPortraitAndUp]: {
      iframeWrap: {
        marginTop: -theme.spacing.small,
        marginRight: -theme.spacing.small,
        marginLeft: -theme.spacing.small,
        paddingBottom: 0
      }
    },
    [theme.mediaQuery.desktopAndUp]: {
      iframeWrap: {
        height: '92%',
        marginTop: -theme.spacing.default,
        marginRight: theme.spacing.default * -2,
        marginLeft: theme.spacing.default * -2
      }
    }
  };
}

export default useSheet(applyStyles)(ContentModal);
